<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<template>
  <div>{{ text }}</div>
</template>
